export enum CardStatuses {
  CRD_BLOCKED = 'CRD_BLOCKED',
  CRD_EXPIRED = 'CRD_EXPIRED',
  CRD_ACTIVATED = 'CRD_ACTIVATED',
  CRD_DEACTIVATED = 'CRD_DEACTIVATED',
  CRD_VALID = 'CRD_VALID',
  CRD_LOST = 'CRD_LOST'
}
